const TransactionFilterButton = ({
                                     onClick,
                                 }) => {
    return (
        <button
            type="button"
            className="tx-btn tx-btn--filter"
            onClick={onClick}
            aria-label="Toggle filters"
        >
            <svg width="14" height="14" viewBox="0 0 18 18" fill="none"
                 stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="M2 4.5h14M5 9h8M7.5 13.5h3"/>
            </svg>
            <span>
                Filters
            </span>
        </button>
    );
};

export default TransactionFilterButton;